import { configureStore } from '@reduxjs/toolkit';

import { cartReducer } from './reducers/cartSlice';
import { isOpenReducer } from './reducers/isOpenSlice';
import { searchReducer } from './reducers/searchSlice';
import { shoppingCardReducer } from './reducers/shoppingCardSlice';
import { sidebarReducer } from './reducers/sidebarSlice';

import { categoryListReducers, categoryDetailsReducers } from './ownReducers/categoryReducers';
import { productsBycategoryDetailsReducers, productsBycategoryListReducers, productListReducers } from './ownReducers/productByCategoryReducers';
import { locationListReducers, locationDetailsReducers } from './ownReducers/locationReducers';
import { blogDetailsReducers, blogListReducers } from './ownReducers/blogReducers';
import { singleProductDetailsReducers, singleProductListReducers } from './ownReducers/singleProductReducers';
import { sliderDetailsReducers, sliderListReducers } from './ownReducers/sliderReducers';
import { couponDetailsReducers, couponListReducers } from './ownReducers/couponReducers';
import { reviewDetailsReducers, reviewListReducers } from './ownReducers/reviewReducers';
import { contactusFormReducers } from './ownReducers/contactusReducers';
import { checkOutFormReducers, checkOutListReducers } from './ownReducers/checkOutReducers';
import { shippingAddressReducer, userProfileFormReducers } from './ownReducers/updateProfileReducers';

import { searchListReducer } from './ownReducers/searchReducer';

import {
  userLoginReducer,
  userRegisterReducer,
  userDetailsReducer,
  userUpdateProfileReducer,
  userListReducer,
  userDeleteReducer,
  userUpdateReducer,
  otpRequestReducer,
  otpVerifyReducer,
  changePasswordReducer,
} from './ownReducers/userReducers';

import { CategoryLocationMapingListReducers } from './ownReducers/categoryLocationMapingReducers';
import { privacyPolicyDetailsReducers, privacyPolicyListReducers } from './ownReducers/privacyPolicyReducers';
import { FaqsQADetailsReducers, FaqsQAListReducers } from './ownReducers/faqsReducers';
import { orderPlaceFormReducers, orderPlaceListReducers, singleOrderPlaceListReducers } from './ownReducers/orderPlaceReducers';
import { ourTeamDetailsReducers, ourTeamListReducers } from './ownReducers/ourTeamReducers';
import { languageReducer } from './ownReducers/languageReducer';
import { locationReducer } from './ownReducers/locationReducer';

/* Safely pull localStorage data */
let cartItemsFromStorage = [];
let userInfoFromStorage = null;
let shippingAddressFromStorage = {};

if (typeof window !== 'undefined') {
  try {
    cartItemsFromStorage = localStorage.getItem('cartItems')
      ? JSON.parse(localStorage.getItem('cartItems'))
      : [];
  } catch {
    cartItemsFromStorage = [];
  }

  try {
    userInfoFromStorage = localStorage.getItem('userInfo')
      ? JSON.parse(localStorage.getItem('userInfo'))
      : null;
  } catch {
    userInfoFromStorage = null;
  }

  try {
    shippingAddressFromStorage = localStorage.getItem('shippingAddress')
      ? JSON.parse(localStorage.getItem('shippingAddress'))
      : {};
  } catch {
    shippingAddressFromStorage = {};
  }
}

const preloadedState = {
  cart: {
    cartItems: cartItemsFromStorage,
  },
  shippingAddress: shippingAddressFromStorage,
  userLogin: {
    userInfo: userInfoFromStorage,
  },
};

const store = configureStore({
  reducer: {
    searchList:searchListReducer,
    language: languageReducer,
    location: locationReducer,
    blogList: blogListReducers,
    blogDetails: blogDetailsReducers,
    locationList: locationListReducers,
    locationDetails: locationDetailsReducers,
    ourTeamList: ourTeamListReducers,
    ourTeamDetails: ourTeamDetailsReducers,
    productList: productListReducers,
    productsBycategoryList: productsBycategoryListReducers,
    productsBycategoryDetails: productsBycategoryDetailsReducers,
    categoryList: categoryListReducers,
    categoryDetails: categoryDetailsReducers,
    singleProductList: singleProductListReducers,
    singleProductDetails: singleProductDetailsReducers,
    sliderList: sliderListReducers,
    sliderDetails: sliderDetailsReducers,
    couponList: couponListReducers,
    couponDetails: couponDetailsReducers,
    reviewList: reviewListReducers,
    reviewDetails: reviewDetailsReducers,
    contactusForm: contactusFormReducers,
    checkOutForm: checkOutFormReducers,
    checkOutList: checkOutListReducers,
    shippingAddress: shippingAddressReducer,
    userProfileForm: userProfileFormReducers,
    orderPlaceForm: orderPlaceFormReducers,
    orderPlaceList: orderPlaceListReducers,
    singleOrderPlaceList: singleOrderPlaceListReducers,
    CategoryLocationMapingList: CategoryLocationMapingListReducers,
    privacyPolicyList: privacyPolicyListReducers,
    privacyPolicyDetails: privacyPolicyDetailsReducers,
    FaqsQAList: FaqsQAListReducers,
    FaqsQADetails: FaqsQADetailsReducers,
    userLogin: userLoginReducer,
    otpRequest: otpRequestReducer,
    otpVerify: otpVerifyReducer,
    userRegister: userRegisterReducer,
    userDetails: userDetailsReducer,
    userUpdateProfile: userUpdateProfileReducer, // fixed typo here
    userList: userListReducer,
    userDelete: userDeleteReducer,
    userUpdate: userUpdateReducer,
    changePassword: changePasswordReducer,
    shoppingCard: shoppingCardReducer,
    sidebar: sidebarReducer,
    cart: cartReducer,
    search: searchReducer,
    isOpen: isOpenReducer,
  },
  preloadedState,
  devTools: true,
});

export default store;
